import { DDSTypography } from 'den-design-system'
import React from 'react'
import Tooltip from '../../New/Tooltip/Tooltip'
import pallete from '../../../global/newPallete'

interface BasicDetailsCardProps {
  id: any
  heading: string
  content: string | React.ReactNode
  height?: string
  EventType?: boolean
  isRed?: boolean
  isGreen?: boolean
}

const BasicDetailsCard: React.FC<BasicDetailsCardProps> = ({
  id,
  heading,
  content,
  height,
  EventType,
  isRed,
  isGreen
}) => {
  const generateRandomId = () => {
    return (Math.random() + 1).toString(36).substring(7)
  }
  return (
    <div
      id={id}
      className='relative flex he flex-col rounded-md border  px-[20px] py-[16px]'
      style={{ borderColor: pallete.colors.stroke2, height: height }}
    >
      <DDSTypography.Paragraph
        size='para'
        variant='regular'
        color={pallete.colors.textDark5}
      >
        {heading}
      </DDSTypography.Paragraph>
      {EventType !== true ? (
        <div className='pt-[8px] '>
          <Tooltip
            id={generateRandomId()}
            position='top'
            className={`override-tooltip-arrow max-w-[95%] break-all ${
              typeof content === 'string' && content.length > 28
                ? content
                : '!hidden'
            }`}
            label={
              <DDSTypography.Paragraph
                size='para'
                variant='regular'
                color={pallete.colors.primary2}
                className='max-w-[900px] break-words'
              >
                {content || '-'}
              </DDSTypography.Paragraph>
            }
          >
            <DDSTypography.Paragraph
              size='para'
              variant='semiBold'
              color={
                isRed
                  ? pallete.colors.warningRed2
                  : isGreen
                    ? pallete.colors.warningGreen
                    : pallete.colors.textDark3
              }
              className='break-words'
            >
              {content || '-'}
            </DDSTypography.Paragraph>
          </Tooltip>
        </div>
      ) : (
        <div className='pt-[8px] '>
          <DDSTypography.Title
            type='h5'
            variant='semiBold'
            color={
              isRed
                ? pallete.colors.warningRed2
                : isGreen
                  ? pallete.colors.warningGreen
                  : pallete.colors.textDark3
            }
            className='break-words'
          >
            {content || '-'}
          </DDSTypography.Title>
        </div>
      )}
    </div>
  )
}

export default BasicDetailsCard
